(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["collection-template"]) return;
  try {
    
	jQuery( document ).ready( function($) {
       $( document ).on( 'click', '.sub-menu-toggle', function() {
			$( this ).parent().find( 'ul.menu-inner' ).slideToggle();
		} );
	} );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-template"] && !window.DesignMode) return;
  try {
    
jQuery( document ).ready( function($) { 
	$( document ).on( 'click', '.faq-que', function() {
		$( this ).toggleClass( 'open' );
		$( this ).next().slideToggle();
	} );
} );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram-social"] && !window.DesignMode) return;
  try {
    
  	// Instagram feed
    var feed = new Instafeed({
      clientId: clientID,
      accessToken: accessToken,
      get: "user",
      userId: userID,
      limit:'6',
	  resolution: 'standard_resolution'
    });
    feed.run();

  } catch(e) { console.error(e); }
})();

})();
